
import { Component, Vue } from 'vue-property-decorator'
import {
  chooseUserType,
  CompanyInfo,
  getCompanyList,
  checkUnbindable
} from '@/api/creatCompany'
import {getPreCredit, getPreCreditUrl} from '@/api/preCredit'
import { Action, Getter } from 'vuex-class'
import { LoginReturnDataDto, toAccountSetting,openNewPage,backToBefore } from '@/utils/h5ToApp'
import store from '@/store'
import { downloadUrl } from '@/utils/util'
import Bridge from '@/utils/bridge'

Component.registerHooks(['beforeRouteEnter'])

@Component({
  name: 'ChooseCompany'
})
export default class ChooseCompany extends Vue {
  @Getter mobile!: string
  @Getter userId!: string
  @Getter info!: LoginReturnDataDto
  @Action setCompanyId!: (val: string) => void
  @Action setCompanyName!: (val: string) => void
  @Action setUserId!: (val: string) => void

  companyInfoList: CompanyInfo[] = []
  params = {
    pageIndex: 1,
    pageSize: 10,
    registMobile: ''
  }
  fromPage = '1' // 从登录页进入此页面时值为1，从切换公司功能进入时值为2，默认1
  showEmpty = false
  show = false
  canPreCredit = false
  msg1 = ''
  msg2 = ''


  get isBackShow() {
    return this.$route.query.setUp === '1'
  }

  activated() {
    window.sessionStorage.getItem('isRefresh') === '1' && this.getList()
  }

  created() {
    this.fromPage = this.$route.query.fromPage as string
    // 防止没有选择公司退出后companyId清空的情况
    // this.setCompanyId('')
    // this.setCompanyName('')
    this.getList()
    // let params = {
    //   color: 'DD2525'
    // }
    // this.$bridge.callHandler('changeStatusBarBackgroundColor', params, (res) => {
    // })
  }

  handleBack() {
    backToBefore()
  }

  getList() {
    window.sessionStorage.setItem('isRefresh', '0')
    this.params.registMobile = this.mobile

    getCompanyList(this.params)
      .then((res) => {
        console.log('res', res)

        this.companyInfoList = res.data || []
      })
      .catch(() => {})
      .finally(() => {
        this.showEmpty = true
      })
  }

  /**
  * @description: 获取预授信免登陆接口
  * @param {*} null
  * @return {*} null
  */
  handleConfirm() {
    console.log('userType',this.info.userType);
    let type = this.info.userType
    let params:any = {
      userId:this.userId
    }
    if(type === '2') {
      params = {
        userId2:this.userId
      }
    }
    if(!this.canPreCredit) return
    getPreCreditUrl(params).then(res => {
        console.log('getPreCreditUrl',res);
        openNewPage({url: encodeURI(res.data.redirectUrl)})
    })
  }
  /**
   * @description: 预授信入口
   * @param {*}
   * @return {*}
   */
  handlePreCredit() {
    console.log('userType',this.info.userType);
    let type = this.info.userType
    let params:any = {
      userId:this.userId
    }
    if(type === '2') {
      params = {
        userId2:this.userId
      }
    }
    this.msg1 = ''
    this.msg2 = ''
    this.show = true
    getPreCredit(params).then((res) => {
      console.log('getPreCredit', res)
      if (res.code === '000000') {
        this.canPreCredit = true
      } else if (res.code === '000002') {
        this.canPreCredit = false
      }
      this.msg1 = res.data.msg
      this.msg2 = res.data.msg2
    })
  }

  ///解除绑定
  releaseClick(item: CompanyInfo) {
    if (item.isIdentification == '1' && item.userOtherType == '1') {
      this.$dialog
        .alert({
          message: `您已认证为【${item.companyName}】的法定代表人，不可解绑该公司账号。如有疑问，请联系我司工作人员。`
        })
        .then(() => {
          // on close
        })
    } else {
      checkUnbindable({ userId2: item.userId, companyId: item.companyId }).then(
        (res) => {
          // 是否可解除绑定
          let unbindable = res.data.unbindable
          if (unbindable) {
            this.$router.push({
              path: '/unbind',
              query: {
                userId: item.userId,
                loginName: item.loginName
              }
            })
          } else {
            this.$toast('该账号不可解除绑定')
          }
        }
      )
    }
  }

  /* 切换用户账号信息 */
  chooseType() {
    if (this.fromPage === '2') {
      const param = {
        oldUserId: this.userId // 登录账号userId
      }
      chooseUserType(param)
        .then((res) => {
          const data = res.data
          this.$store.commit('SET_TOKEN', data.access_token)
          this.$store.commit('SET_INFO', data)
          this.$store.commit('SET_USERID', data.userId)
          this.getList()
        })
        .catch(() => {})
    } else {
      this.getList()
    }
  }

  ///进入选中公司
  enterCompany(item: CompanyInfo) {
    const param = {
      oldUserId: this.info.userId, // 登录账号userId
      userId: item.userId // 新创建的公司对应的userId
    }
    chooseUserType(param)
      .then((res) => {
        const data = res.data
        this.setCompanyId(item.companyId)
        this.setCompanyName(item.companyName)
        this.setUserId(item.userId)

        // 2.0需求进去公司传入
        // this.$store.commit('SET_COMPANY_CurrentVersion',item.currentVersion)
        // this.$store.commit('SET_COMPANY_VersionCode', item.versionCode)
        // this.$store.commit('SET_COMPANY_IsIdentification',item.isIdentification)
        // this.$store.commit('SET_COMPANY_IsExpiration',item.isExpiration)
        // this.$store.commit('SET_COMPANY_ExpirationTime', item.expirationTime)
        // this.$store.commit('SET_COMPANY_Trial', item.trial)
        // this.$store.commit('SET_COMPANY_PartnerCompanyId', item.partnerCompanyId)
        if (this.$checkIsEmpty(item.currentVersion)) {
          item.currentVersion = 'system'
        }
        const obj = {
          companyInfo: item,
          userInfo: { ...data, currentVersion: item.currentVersion },
          logoUrl: window.location.origin + this.$downloadUrl(item.logoUrl), // 完整的url地址
          res: JSON.stringify(res)
        }
        this.$bridge.callHandler('enterCompany', obj, (res) => {
          console.log(res)
        })
      })
      .catch(() => {})
  }

  ///创建公司
  createCompany() {
    this.$router.push({
      path: '/createCompany',
      query: {
        fromPage: '1'
      }
    })
  }

  // 账号设置
  toSetting() {
    const obj = {
      userType: this.info.userType
    }
    toAccountSetting(obj)
  }

  beforeRouteEnter(to, from, next) {
    // 如果原生跳转到这个界面时有携带 companyId 则直接进入这个 companyId这个公司
    if (
      to.query.fromPage === '1' &&
      to.query.companyId &&
      to.name === 'ChooseCompany'
    ) {
      let params = {
        pageIndex: 1,
        pageSize: 1000, // 由于请求公司列表接口是分页的,但是要拿列表和原生传入companyId做比较,闲将pageSize调大
        registMobile: store.state.user.mobile
      }
      getCompanyList(params)
        .then((res) => {
          let companyInfoList = res.data || []
          let companyId = to.query.companyId as string
          companyInfoList = res.data || []
          let companyInfo = companyInfoList.filter(
            (item) => item.companyId === companyId
          )[0]

          const param = {
            oldUserId: store.state.user.info.userId, // 登录账号userId
            userId: companyInfo.userId // 新创建的公司对应的userId
          }
          chooseUserType(param)
            .then((res) => {
              const data = res.data
              store.dispatch('setCompanyId', companyInfo.companyId)
              store.dispatch('setCompanyName', companyInfo.companyName)
              store.commit('SET_TOKEN', data.access_token)
              store.commit('SET_INFO', data)
              store.commit('SET_USERID', data.userId)
              const obj = {
                companyInfo: companyInfo,
                userInfo: data,
                logoUrl:
                  window.location.origin + downloadUrl(companyInfo.logoUrl), // 完整的url地址
                res: JSON.stringify(res)
              }
              Bridge.callHandler('enterCompany', obj, (res) => {
                console.log(res)
              })
            })
            .catch(() => {})
        })
        .catch(() => {})
    } else {
      next()
    }
  }
}
